import { render, staticRenderFns } from "./WorkOrderItem.vue?vue&type=template&id=b2373cfe&scoped=true&"
import script from "./WorkOrderItem.vue?vue&type=script&lang=js&"
export * from "./WorkOrderItem.vue?vue&type=script&lang=js&"
import style0 from "./WorkOrderItem.vue?vue&type=style&index=0&id=b2373cfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2373cfe",
  null
  
)

export default component.exports